import React, { useEffect, useState } from 'react';
import { Accordion, Container, Form, InputGroup, Spinner, Row, Col, Button, Modal, Alert } from 'react-bootstrap';
import LoadThongTinService from '../../services/LoadThongTinService';
import DriverService from '../../services/DriverService';
import Select from 'react-select';
import './style.css'; // Import CSS

const XemThongTinDaNhapComponent = () => {
  const [data, setData] = useState([]); // Dữ liệu gốc
  const [filteredData, setFilteredData] = useState([]); // Dữ liệu đã lọc
  const [loading, setLoading] = useState(true); // Trạng thái tải dữ liệu
  const [searchTerm, setSearchTerm] = useState(''); // Từ khóa tìm kiếm
  const [selectedDate, setSelectedDate] = useState(''); // Ngày khởi hành đã chọn
  const [showModal, setShowModal] = useState(false); // Trạng thái hiển thị modal
  const [showConfirmDelete, setShowConfirmDelete] = useState(false); // Trạng thái hiển thị modal xác nhận xóa
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // success or danger
  const [editData, setEditData] = useState({
    id: '',
    bien_kiem_soat: '',
    ma_chuyen: '',
    ngay_khoi_hanh: '',
    gio_di: '',
    gio_den: '',
    diem_di: '',
    loai_chay: '',
    diem_den: '',
    km_dau: '',
    km_cuoi: '',
    so_kien_tai: '',
    len_xe: '',
    xuong_xe: '',
    ma_buu_cuc: '',
    ghi_chu: ''
  }); // Dữ liệu cần chỉnh sửa
  const [deleteId, setDeleteId] = useState(null); // ID của bản ghi cần xóa
  const [bienKiemSoatOptions, setBienKiemSoatOptions] = useState([]);
  const [buuCucOptions, setBuuCucOptions] = useState([]); // Danh sách cho Điểm đi, Điểm đến, Đơn vị sử dụng


  const fetchData = async () => {
    try {
      const response = await DriverService.getUserData();
      setData(response.data); // Lưu dữ liệu vào state
      setFilteredData(response.data); // Khởi tạo dữ liệu đã lọc
    } catch (error) {
      console.error('Lỗi khi lấy dữ liệu:', error);
    } finally {
      setLoading(false); // Tắt trạng thái tải
    }
  };
  // Lấy danh sách biển kiểm soát từ API khi component mount
  const fetchBienKiemSoat = async () => {
    try {
      const response = await LoadThongTinService.getBienKiemSoat();
      setBienKiemSoatOptions(response.data);
    } catch (error) {
      console.error("Error fetching biển kiểm soát:", error);
    }
  };

  // Lấy danh sách điểm đi, điểm đến, đơn vị sử dụng từ API khi component mount
  const fetchMaBuuCuc = async () => {
    try {
      const response = await LoadThongTinService.getMaBuuCuc();
      setBuuCucOptions(response.data); // Gán danh sách từ API
    } catch (error) {
      console.error("Error fetching ma buu cuc:", error);
    }
  };
  // Gọi API khi component được mount
  useEffect(() => {
    fetchBienKiemSoat();
    fetchMaBuuCuc();
    fetchData();
  }, []);

  // Tự động đóng Alert sau 5 giây
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage('');
      }, 5000); // 5000ms = 5 giây

      // Cleanup function để tránh memory leaks khi component unmount
      return () => clearTimeout(timer);
    }
  }, [message]);

  // Lọc dữ liệu khi `searchTerm` hoặc `selectedDate` thay đổi
  useEffect(() => {
    const term = searchTerm.toLowerCase();
    const filtered = data.filter((item) => {
      const itemDate = new Date(item[3]).toISOString().split('T')[0];
      const matchesSearchTerm =
        item[2].toLowerCase().includes(term) || item[1].toLowerCase().includes(term);
      const matchesDate = selectedDate === '' || itemDate === selectedDate;
      return matchesSearchTerm && matchesDate;
    });
    setFilteredData(filtered);
  }, [searchTerm, selectedDate, data]);

  // Hiển thị modal khi bấm "Sửa thông tin"
  const handleShowModal = (item) => {
    console.log(item, bienKiemSoatOptions);
    setEditData({
      id: item[18],
      bien_kiem_soat: item[1],
      ma_chuyen: item[2],
      ngay_khoi_hanh: item[3],
      gio_di: item[6],
      gio_den: item[7],
      diem_di: item[8],
      loai_chay: item[4],
      diem_den: item[9],
      km_dau: item[10],
      km_cuoi: item[11],
      so_kien_tai: item[13],
      len_xe: item[14],
      xuong_xe: item[15],
      ma_buu_cuc: item[16],
      ghi_chu: item[17],
    });
    setShowModal(true);
  };


  // Xử lý việc cập nhật thông tin khi submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Kiểm tra các điều kiện hợp lệ
      if (editData.km_dau > editData.km_cuoi) {
        setMessage("Km đầu không được lớn hơn Km cuối.");
        setMessageType('danger');
        return;
      }
      if (editData.km_dau < 0 || editData.km_cuoi < 0) {
        setMessage("Km phải lớn hơn 0.");
        setMessageType('danger');
        return;
      }
      if (editData.len_xe < editData.xuong_xe) {
        setMessage("Trọng lượng xuống xe không được lớn hơn trọng lượng lên xe.");
        setMessageType('danger');
        return;
      }
      if (editData.len_xe < 0 || editData.xuong_xe < 0) {
        setMessage("Trọng lượng phải lớn hơn 0.");
        setMessageType('danger');
        return;
      }

      // Chuyển đổi ngay_khoi_hanh sang định dạng yyyy-mm-dd
      const ngayKhoiHanhDate = new Date(editData.ngay_khoi_hanh);
      const formattedNgayKhoiHanh = ngayKhoiHanhDate.toISOString().split('T')[0]; // yyyy-mm-dd format

      // Cập nhật ngay_khoi_hanh trong editData với định dạng chuẩn
      const updatedData = { ...editData, ngay_khoi_hanh: formattedNgayKhoiHanh };

      // Gọi API cập nhật thông tin
      await DriverService.capNhatThongTinDaNhap(updatedData);
      fetchData();

      setShowModal(false); // Đóng modal sau khi cập nhật thành công

      // Hiển thị thông báo thành công
      setMessage("Cập nhật thông tin thành công!");
      setMessageType('success');
    } catch (error) {
      console.error('Lỗi khi cập nhật thông tin:', error);
      setMessage('Lỗi khi cập nhật thông tin.');
      setMessageType('danger');
    }
  };


  // Xử lý xóa thông tin (chỉ xóa sau khi người dùng xác nhận)
  const handleDelete = async () => {
    try {
      await DriverService.xoaThongTinDaNhap(deleteId);
      setShowConfirmDelete(false); // Đóng modal xác nhận

      // Cập nhật thông báo thành công
      setMessage('Xóa chuyến thành công!');
      setMessageType('success');

      // Gọi lại API hoặc cập nhật state để làm mới dữ liệu sau khi xóa thành công
      fetchData();
    } catch (error) {
      console.error('Lỗi khi xóa thông tin:', error);

      // Cập nhật thông báo lỗi
      setMessage('Lỗi khi xóa chuyến!');
      setMessageType('danger');
    }
  };

  // Hiển thị modal xác nhận xóa
  const handleShowConfirmDelete = (id) => {
    setDeleteId(id); // Lưu ID bản ghi cần xóa
    setShowConfirmDelete(true); // Hiển thị modal xác nhận xóa
  };

  // Hiển thị spinner khi dữ liệu đang tải
  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p>Đang tải dữ liệu...</p>
      </Container>
    );
  }

  return (
    <Container fluid className="mt-5 xem-thong-tin-da-nhap">
      {/* Hiển thị thông báo nếu có message */}
      {message && (
        <Alert style={{ position: 'fixed', top: '80px', zIndex: '1001' }} variant={messageType} onClose={() => setMessage('')} dismissible>
          {message}
        </Alert>
      )}
      <h2 className="text-center mb-4">Danh sách các chuyến xe</h2>

      {/* Thanh tìm kiếm */}
      <InputGroup className="mb-3">
        <Form.Control
          type="text"
          placeholder="Tìm kiếm theo mã chuyến hoặc biển kiểm soát..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)} // Cập nhật searchTerm
        />
      </InputGroup>

      {/* Chọn ngày khởi hành */}
      <InputGroup className="mb-3">
        <Form.Group controlId="selectedDate" className="w-100">
          <Form.Label>Chọn ngày khởi hành</Form.Label>
          <Form.Control
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </Form.Group>
      </InputGroup>

      {/* Accordion hiển thị dữ liệu */}
      <Accordion>
        {filteredData.length === 0 ? (
          <p className="text-center">Không tìm thấy chuyến xe nào.</p>
        ) : (
          filteredData.map((item, index) => (
            <Accordion.Item key={index} eventKey={index.toString()}>
              <Accordion.Header>
                <div className="d-flex justify-content-between w-100">
                  <span>{item[2]}</span>
                  <span>{item[1]}</span>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col md={6}>
                    <p><strong>Ngày khởi hành:</strong> {new Date(item[3]).toLocaleDateString()}</p>
                    <p><strong>Loại chạy:</strong> {item[4]}</p>
                    <p><strong>Thời gian nhập liệu:</strong> {new Date(item[5]).toLocaleDateString()}</p>
                    <p><strong>Giờ đi:</strong> {item[6]}</p>
                    <p><strong>Giờ đến:</strong> {item[7]}</p>
                    <p><strong>Điểm đi:</strong> {item[8]}</p>
                    <p><strong>Điểm đến:</strong> {item[9]}</p>
                  </Col>
                  <Col md={6}>
                    <p><strong>Km đầu:</strong> {item[10]}</p>
                    <p><strong>Km cuối:</strong> {item[11]}</p>
                    <p><strong>Tổng km đã di chuyển:</strong> {item[12]}</p>
                    <p><strong>Số kiện tải:</strong> {item[13]}</p>
                    <p><strong>Trọng lượng lên xe:</strong> {item[14]}</p>
                    <p><strong>Trọng lượng xuống xe:</strong> {item[15]}</p>
                    <p><strong>Ghi chú:</strong> {item[17]}</p>
                  </Col>
                </Row>
                {/* Nút "Sửa thông tin" và "Xóa" */}
                <Button variant="warning" onClick={() => handleShowModal(item)}>Sửa thông tin</Button>
                <Button variant="danger" onClick={() => handleShowConfirmDelete(item[18])}>Xóa</Button>
              </Accordion.Body>
            </Accordion.Item>
          ))
        )}
      </Accordion>


      {/* Modal chỉnh sửa thông tin */}
      <Modal className="xem-thong-tin-da-nhap" show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Sửa thông tin chuyến xe</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editData && (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Mã chuyến</Form.Label>
                <Form.Control
                  type="text"
                  value={editData.ma_chuyen}
                  onChange={(e) => setEditData({ ...editData, ma_chuyen: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Biển kiểm soát</Form.Label>
                <Select
                  id="bien_kiem_soat"
                  name="bien_kiem_soat"
                  options={bienKiemSoatOptions.map(option => ({ value: option, label: option }))}
                  placeholder="Chọn biển kiểm soát"
                  value={{ value: editData.bien_kiem_soat, label: editData.bien_kiem_soat }}
                  onChange={(selectedOption) => setEditData({ ...editData, bien_kiem_soat: selectedOption.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Ngày khởi hành</Form.Label>
                <Form.Control
                  type="date"
                  value={
                    editData.ngay_khoi_hanh ? new Date(editData.ngay_khoi_hanh).toISOString().split('T')[0] : ''
                  }
                  onChange={(e) => setEditData({ ...editData, ngay_khoi_hanh: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Loại chạy</Form.Label>
                <Form.Select
                  value={editData.loai_chay}
                  onChange={(e) => setEditData({ ...editData, loai_chay: e.target.value })}
                  className="dropdown-limit"  // Áp dụng lớp CSS giới hạn chiều cao
                >
                  <option value="" disabled></option>
                  <option value="Kết Nối Đi">Kết Nối Đi</option>
                  <option value="Kết Nối Về">Kết Nối Về</option>
                  <option value="Phát Hàng">Phát Hàng</option>
                  <option value="Phục Vụ Thu Điểm Cuối">Phục Vụ Thu Điểm Cuối</option>
                  <option value="Phục Vụ Phát Điểm Cuối">Phục Vụ Phát Điểm Cuối</option>
                  <option value="Phục Vụ Thu Giữa HT">Phục Vụ Thu Giữa HT</option>
                  <option value="Phục Vụ Phát Giữa HT">Phục Vụ Phát Giữa HT</option>
                  <option value="Kinh Doanh">Kinh Doanh</option>
                  <option value="Kinh Doanh Có Nhận Chuyến VTMan">Kinh Doanh Có Nhận Chuyến VTMan</option>
                  <option value="Kinh Doanh Không Nhận Chuyến VTMan">Kinh Doanh Không Nhận Chuyến VTMan</option>
                  <option value="Đăng Kiểm">Đăng Kiểm</option>
                  <option value="Sửa Chữa">Sửa Chữa</option>
                  <option value="Di Chuyển Từ Bãi Xe">Di Chuyển Từ Bãi Xe</option>
                  <option value="Khác (Giải trình vào ghi chú)">Khác (Giải trình vào ghi chú)</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Giờ đi</Form.Label>
                <Form.Control
                  type="time"
                  value={editData.gio_di ? editData.gio_di.slice(0, 5) : ''}  // Chỉ lấy HH:MM từ chuỗi thời gian
                  onChange={(e) => setEditData({ ...editData, gio_di: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Giờ đến</Form.Label>
                <Form.Control
                  type="time"
                  value={editData.gio_den ? editData.gio_den.slice(0, 5) : ''}  // Chỉ lấy HH:MM từ chuỗi thời gian
                  onChange={(e) => setEditData({ ...editData, gio_den: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Điểm đi</Form.Label>
                <Select
                  options={buuCucOptions.map(option => ({ value: option, label: option }))}
                  placeholder="Chọn điểm đi"
                  onChange={(selected) => setEditData({ ...editData, diem_di: selected.value })}
                  value={{ value: editData.diem_di, label: editData.diem_di }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Điểm đến</Form.Label>
                <Select
                  options={buuCucOptions.map(option => ({ value: option, label: option }))}
                  placeholder="Chọn điểm đi"
                  onChange={(selected) => setEditData({ ...editData, diem_den: selected.value })}
                  value={{ value: editData.diem_den, label: editData.diem_den }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Km đầu</Form.Label>
                <Form.Control
                  type="number"
                  value={editData.km_dau}
                  onChange={(e) => setEditData({ ...editData, km_dau: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Km cuối</Form.Label>
                <Form.Control
                  type="number"
                  value={editData.km_cuoi}
                  onChange={(e) => setEditData({ ...editData, km_cuoi: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Đơn vị sử dụng</Form.Label>
                <Select
                  options={buuCucOptions.map(option => ({ value: option, label: option }))}
                  placeholder="Chọn đơn vị sử dụng"
                  onChange={(selected) => setEditData({ ...editData, ma_buu_cuc: selected.value })}
                  value={{ value: editData.ma_buu_cuc, label: editData.ma_buu_cuc }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Số kiện tải</Form.Label>
                <Form.Control
                  type="number"
                  value={editData.so_kien_tai}
                  onChange={(e) => setEditData({ ...editData, so_kien_tai: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Trọng lượng lên xe</Form.Label>
                <Form.Control
                  type="number"
                  value={editData.len_xe}
                  onChange={(e) => setEditData({ ...editData, len_xe: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Trọng lượng xuống xe</Form.Label>
                <Form.Control
                  type="number"
                  value={editData.xuong_xe}
                  onChange={(e) => setEditData({ ...editData, xuong_xe: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Ghi chú</Form.Label>
                <Form.Control
                  type="text"
                  value={editData.ghi_chu}
                  onChange={(e) => setEditData({ ...editData, ghi_chu: e.target.value })}
                />
              </Form.Group>
              <Button variant="primary" type="submit">Lưu thay đổi</Button>
              <Button variant="secondary" onClick={() => setShowModal(false)}>Đóng</Button>
            </Form>
          )}
        </Modal.Body>
      </Modal>

      {/* Modal xác nhận xóa */}
      <Modal className="xem-thong-tin-da-nhap" show={showConfirmDelete} onHide={() => setShowConfirmDelete(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Xác nhận xóa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Bạn có chắc chắn muốn xóa chuyến xe này không?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleDelete}>Có, xóa</Button>
          <Button variant="secondary" onClick={() => setShowConfirmDelete(false)}>Hủy</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default XemThongTinDaNhapComponent;
